import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import React from "react";

import useStyles from "./styles";
import { useTranslation } from "react-i18next";

const DialogAlert = ({ message, onOpen, onClose, textOk, textCancel, onOk, onCancel, title }) => {
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<Dialog
			onClose={onClose}
			open={onOpen}
			PaperProps={{
				style: { borderRadius: 30, maxHeight: 350, maxWidth: 312 },
			}}>
			<DialogTitle className={classes.text}>{title || t("Ocorreu um erro")}</DialogTitle>
			<div className={classes.content}>
				<DialogContentText className={classes.text}>{message}</DialogContentText>
			</div>
			<div className={classes.buttonActions}>
				<Button className={classes.buttonOk} onClick={onOk}>
					{textOk || t("Ok")}
				</Button>
				{onCancel && (
					<Button className={classes.buttonCancel} onClick={onCancel}>
						{textCancel || t("Cancelar")}
					</Button>
				)}
			</div>
		</Dialog>
	);
};

export default DialogAlert;
